import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators, ReactiveFormsModule } from '@angular/forms';
import { DeudaService } from 'src/app/services/deuda/deuda.service';
import { ProductoService } from 'src/app/services/producto/producto.service';
import { CommonModule } from '@angular/common';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ProductoResponse } from 'src/app/core/dtos/productoResponse';
import { CrearDeudaRequest } from 'src/app/core/dtos/crearDeudaRequest';
@Component({
  selector: 'app-crear-deuda',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './crear-deuda.component.html',
  styleUrl: './crear-deuda.component.css',
  standalone: true
})
export class CrearDeudaComponent implements OnInit {
clienteId!: number;
  form!: FormGroup;
  productosDisponibles: ProductoResponse[] = [];
  loading = false;
  error = '';
  usuarioId!: number;
  request: CrearDeudaRequest = { clienteId: 0, productos: [] };
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private deudaService: DeudaService,
    private productoService: ProductoService,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit() {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.usuarioId = +(usuarioId ?? 0);
    this.clienteId = +this.route.snapshot.paramMap.get('id')!;
    this.form = this.fb.group({
      clienteId: [this.clienteId],
      productos: this.fb.array([])
    });
    this.cargarProductos();
  }

  get productos() {
    return this.form.get('productos') as FormArray;
  }

  agregarProducto() {
    this.productos.push(this.fb.group({
      productoId: ['', Validators.required],
      cantidad: [1, [Validators.required, Validators.min(1)]]
    }));
  }

  removerProducto(index: number) {
    this.productos.removeAt(index);
  }

  cargarProductos() {
    this.productoService.getProductos(this.usuarioId).subscribe({
      next: (res) => this.productosDisponibles = res,
      error: () => this.error = 'Error al cargar productos'
    });
  }

  submit() {
    if (this.form.invalid) return;
    this.request.clienteId = this.clienteId;
    this.request.productos = this.productos.value.map((item: any) => ({
      productoId: item.productoId,
      cantidad: item.cantidad
    }));
    this.loading = true;
    this.deudaService.crearDeuda(this.usuarioId,this.request).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigate([`/cliente/libreta`, this.clienteId]);
      },
      error: () => {
        this.error = 'Error al guardar la deuda';
        this.loading = false;
      }
    });
  }

  volverAtras() {
    this.router.navigate([`/cliente/libreta`, this.clienteId]);
  }
}
